import React, { useContext } from 'react'
import { bool } from 'prop-types'

import { VIEW_MODES } from '../../../constants'
import { ViewModeContext } from '../../../context/viewMode'

import LoadingButton from './LoadingButton'
import MinimalisticLoader from './MinimalisticLoader'

const Loader = ({ minimalisticLoader, ...props }) => {
  const viewMode = useContext(ViewModeContext)
  const isEditorial = viewMode === VIEW_MODES.EDITORIAL

  switch (true) {
    case isEditorial:
    case minimalisticLoader:
      return <MinimalisticLoader {...props} />
    default:
      return <LoadingButton {...props} />
  }
}

Loader.propTypes = {
  minimalisticLoader: bool,
}

export default Loader
